import { render, staticRenderFns } from "./AzulPanel.vue?vue&type=template&id=1995df90&scoped=true"
import script from "./AzulPanel.vue?vue&type=script&lang=js"
export * from "./AzulPanel.vue?vue&type=script&lang=js"
import style0 from "../Dashboard/Partials/SubAgentPanel/styles.scss?vue&type=style&index=0&id=1995df90&prod&scoped=true&lang=scss&external"
import style1 from "./AzulPanel.vue?vue&type=style&index=1&id=1995df90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995df90",
  null
  
)

export default component.exports